export const CREATE_UPDATE_BUTTON = {
  textTransform: "none",
  fontWeight: "500",
  py: 1.3,
  px: 4,
  borderRadius: 2,
  backgroundColor: "#0067de",
  color: "#fff",
};

export const DELETE_BUTTON = {
  textTransform: "none",
  fontWeight: "500",
  py: 1.3,
  px: 4,
  borderRadius: 2,
  backgroundColor: "#d32f2f",
  color: "#fff",
};

export const RESET_CANCEL_BUTTON = {
  textTransform: "none",
  fontWeight: "500",
  fontSize: "15px",
  py: 1.3,
  px: 4,
  marginLeft: 1,
  borderRadius: 2,
  color: "#5a6268",
  "&:hover": {
    backgroundColor: "#d7d7dcff",
  },
};

export const DELETE_ACCOUNT_BUTTON = {
  textTransform: "none",
  fontWeight: "500",
  py: 1.3,
  px: 4,
  borderRadius: 2,
  backgroundColor: "#0067de",
  color: "#fff",
  mb: 2,
};

export const CHOOSE_PLAN = {
  textTransform: "none",
  fontWeight: "700",
  py: 1.3,
  px: 4,
  borderRadius: 2,
  width: "100%",
  BorderColor: "#0067de",
  color: "#0067de",
  marginBottom: 5,
};
